import { utcFormat } from 'd3-time-format';
import { DEFAULT_DATE_FORMAT } from './constants';
import { i18n } from './i18n-instance';

export function formatDateValue(
  date: Date | string,
  formatStr: string = DEFAULT_DATE_FORMAT
): string {
  const parsedDate = typeof date === 'string' ? new Date(date) : date;
  const { t } = i18n.global;

  if (isNaN(parsedDate.getTime())) {
    return t('invalidDate');
  }

  const formatter = utcFormat(formatStr);
  return formatter(parsedDate);
}
